module.exports = __webpack_public_path__ + "img/hit-pract-2.aeae9ce6.svg";